import { useIsOwnProfile } from "containers/profile/hooks/useProfile"
import { useGoogleConnectedStatus } from "./hooks/connect-gmail"
import { DealSyncLoading } from "./DealSyncLoadingCard"
import { UnlockNetwork } from "./UnlockNetwork"
import { DealSyncConnected } from "./DealSyncConnected"

export const DealSyncCard = () => {
  const isOwnProfile = useIsOwnProfile()

  const { data, isLoading } = useGoogleConnectedStatus()
  // const showDealCard = user?.email?.includes('@creatorland.com') || environment.env !== 'production'
  const showDealCard = true

  const isGoogleConnected = data?.gmailConnected

  if (!isOwnProfile || !showDealCard) return null

  if (isLoading) return <DealSyncLoading />

  if (!isGoogleConnected) return <UnlockNetwork />

  return <DealSyncConnected />
}